import type { OptionState } from '@openx/types/options';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery';
import { toList } from '../../targeting/utils/toList';
import { toMapById } from '../../targeting/utils/toMapById';

export const useDistributionChannelOptionsFetch = (): OptionState => {
  const {
    data: { optionsByPath = [] } = {},
    loading,
    refetch,
  } = useOptionsByPathQuery({
    variables: {
      path: 'deal.package.targeting.rendering_context.distribution_channel',
    },
  });

  const list = useMemo(() => toList(optionsByPath), [optionsByPath]);
  const mapById = useMemo(() => toMapById(list), [list]);

  return useMemo(
    () => ({
      list,
      loading,
      mapById,
      refetch,
    }),
    [list, loading, mapById, refetch]
  );
};
